import { Injectable } from '@angular/core';
import { BaseService } from '@plantefeve/common/api/base.service';
import { map, Observable, shareReplay } from 'rxjs';
import { PortalContext } from './portal-context.model';

/**
 * The customer relations linked to the signed-in account (`GET api/portal/me`).
 * Loaded once and shared; a failed request is retried by the next subscriber.
 */
@Injectable({
  providedIn: 'root',
})
export class PortalContextService extends BaseService {
  protected override _route = 'api/portal';

  private readonly _context$ = this._httpClient.get<PortalContext>(`${this._route}/me`).pipe(shareReplay(1));

  public get(): Observable<PortalContext> {
    return this._context$;
  }

  /** Whether the account is linked to at least one customer relation. */
  public isLinked(): Observable<boolean> {
    return this._context$.pipe(map((context) => (context?.relations?.length ?? 0) > 0));
  }
}
